import EnvironmentManager from 'Utils/environmentManager';
import { callNumberFormatter } from 'Utils/callNumberFormatter';

export const customerServiceNumber = EnvironmentManager.getMessageText({ key: 'about_us_customer_service_no' }) || '0850 272 0 272';

export const customerServiceNumberDial = callNumberFormatter(customerServiceNumber);

